import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import '../styles/legal.css';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - Excel Toolbox</title>
        <meta name="description" content="Privacy policy for Excel Toolbox. Learn how we protect your data with local processing and our commitment to user privacy and security." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://exceltoolbox.org/privacy-policy" />
      </Helmet>
      <Container className="legal-container">
        <Card className="legal-card">
          <Card.Body>
            <h1>Privacy Policy</h1>
            <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
            
            <h2 className="h4 mb-3">Introduction</h2>
            <p>ByteBuilder Technologies, LLC ("we", "us", or "our") operates the Excel Toolbox web application. This page informs you of our policies regarding the collection, use, and disclosure of data when you use our service.</p>
            
            <h2 className="h4 mb-3">1. Information We Don't Collect</h2>
            <p>Excel Toolbox processes all files locally in your browser. We do not collect, store, or transmit any of your files or personal information.</p>
            
            <h2 className="h4 mb-3">2. File Processing</h2>
            <p>All Excel file processing occurs entirely within your web browser. Your files are never uploaded to any server.</p>
            
            <h2 className="h4 mb-3">3. Cookies</h2>
            <p>We use only essential cookies necessary for the application to function properly. These cookies do not collect any personal information.</p>
            
            <h2 className="h4 mb-3">4. Third-Party Services</h2>
            <p>Our application may display advertisements from third-party providers. These providers may use cookies and similar technologies for serving relevant ads. Please note that ByteBuilder Technologies, LLC is not responsible for the privacy practices of these third-party services.</p>
            
            <h2 className="h4 mb-3">5. Changes to This Policy</h2>
            <p>ByteBuilder Technologies, LLC reserves the right to update this privacy policy at any time. We will notify users of any material changes by posting the new privacy policy on this page.</p>
            
            <h2 className="h4 mb-3">6. Trademark Disclaimer</h2>
            <p>Excel Toolbox is not affiliated with, endorsed by, or in any way officially connected with Microsoft Corporation or any of its subsidiaries or affiliates. Excel® is a registered trademark of Microsoft Corporation. The name "Excel" as used in Excel Toolbox is for identification purposes only and is used in a nominative manner to describe compatibility with Microsoft Excel files.</p>

            <h2 className="h4 mb-3">7. Contact Us</h2>
            <p>If you have any questions about this Privacy Policy or our practices, please contact us at info@bytebuildertech.com.</p>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
